<div class="deviations mt-3">
  <div class="clearfix">
    <h5 class="float-start mt-1">{{'quantity.deviations'|translate}}</h5>
    <div class="float-end deviation-legend mt-1">
      <div class="me-2">
        <div class="severity bg-warning">&nbsp;</div>
        <div>{{'ui.warning'|translate}}</div>
      </div>
      <div>
        <div class="severity bg-danger">&nbsp;</div>
        <div>{{'ui.blocking'|translate}}</div>
      </div>
    </div>
    <button type="button" class="btn btn-sm btn-outline-secondary float-end me-4" (click)="showDeviations()">
      {{'quantity.deviations'|translate}} {{'ui.and'|translate|lowercase}} {{'ui.details'|translate|lowercase}} {{'ui.show-verb'|translate|lowercase}}
    </button>
  </div>
  <div class="list horizontal">
    <deviation *ngFor="let deviation of visibleDeviations; trackBy: trackByType"
      [subject]="DeviationSubjectType.invoice"
      [subjectId]="0"
      [IDPosition]="0"
      [severity]="deviation.severity"
      [description]="getDescription(deviation.type)"
      [count]="deviation.count">
    </deviation>
  </div>
</div>
